import { render, staticRenderFns } from "./veStuPeriod.vue?vue&type=template&id=2bd12c08&scoped=true"
import script from "./veStuPeriod.vue?vue&type=script&lang=js"
export * from "./veStuPeriod.vue?vue&type=script&lang=js"
import style0 from "./veStuPeriod.vue?vue&type=style&index=0&id=2bd12c08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd12c08",
  null
  
)

export default component.exports